import fetch from 'unfetch';

export const request = {
  async getJson(url) {
    const response = await fetch(url);
    return response.json();
  },
};
